import React from 'react'
import Logo from '../Logo'
import DateTime from '../DateTime'
import { connect } from 'react-redux';

class TitleBar extends React.Component {
  render() {
    return (
      <div id="titlebar">
        <Logo />
        <div className="titlebar-right">
          <div className="titlebar-datetime">
            <DateTime />
          </div>                   
        </div>
      </div>)
  }
}

TitleBar.propTypes = {
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps)(TitleBar)



// WEBPACK FOOTER //
// src/components/CustomerDisplay/TitleBar.jsx